require('./brokerContributionInvestmentFundSuccess.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getFormattedString } = require('utilities/currencyHelper');
const momentTz = require('moment-timezone');
// @ components
const BrokerContributionInvestmentFundDetails = require('../brokerContributionInvestmentFundDetails/brokerContributionInvestmentFundDetails');
// @ commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ constants
const { DATE_FORMAT_COMPLETE, BROKER_MYPROFILE_MYWALLET_URL, FIRST_STEP } = require('constants/index');
// @ utils
const { recordPage, PROC_BROKER_INVESTMENT_CONTRIBUTIONS } = require('utilities/tagging.js');
const { taggingEventHandled } = require('../../../../utilities/taggingEventHandled');
class BrokerContributionInvestmentFundSuccess extends React.Component {


    componentDidMount() {
        const { immContributionFunds } = this.props;
        const customData = {
            event_name: "step_success",
            pageName: "/buyFunds/Periodic/success",
            sectionFamily: "wealth",
            sectionCategory: "products",
            sectionName: "funds",
            serviceType: "productContracting",
            interactionType: "funnel",
            processType: "buyFunds",
            processStep: "success",
            productName: immContributionFunds.getIn(['contributionFunds', 'isin']),
            periodicity: immContributionFunds.getIn(['steps', FIRST_STEP, 'periodicityValue']),
            amount: immContributionFunds.getIn(["steps", FIRST_STEP, "amount"]),
        }
        recordPage(customData)

        taggingEventHandled(PROC_BROKER_INVESTMENT_CONTRIBUTIONS, 'onSuccessNewContrib' );

    }

    buildColumns() {
        const baseColumns = ['account', 'contributionDetails'];
        const columns = [
                'brokerContributionFundSuccess-aplicationDate',
                'brokerContributionFundSuccess-subscriptionFund',
                ...baseColumns
            ];
        return columns;
    }

    buildMessage() {
            return formatText('brokerContributionFundSuccess-successMessage');
    }

    render() {
        const { immContributionFunds, immAccounts } = this.props;
        const fundName = immContributionFunds.getIn(['steps', 0, 'contributionFunds', 'name']);
        const accountNumber = immContributionFunds.getIn(['steps', 0, 'accountNumber']);
        const immAccount = immAccounts.get(accountNumber);

        let columnsContent = [
            momentTz().tz("Europe/Madrid").format(DATE_FORMAT_COMPLETE),
            fundName,
            'account',
            'contributionDetails'
        ];

        const columns = this.buildColumns();
        const successMessage = "La solicitud de contratación se ha enviado con éxito"

        const handleClickMovements = () => {
            taggingEventHandled(PROC_BROKER_INVESTMENT_CONTRIBUTIONS, 'goToMovementsSuccess', { name: fundName, isin: immContributionFunds.getIn(['contributionFunds', 'isin']) });
        }

        const handleClickWallet = () => {
            taggingEventHandled(PROC_BROKER_INVESTMENT_CONTRIBUTIONS, 'goToWallet', { name: fundName, isin: immContributionFunds.getIn(['contributionFunds', 'isin']) });
        }

        return (
            <div className="contribution-fund-success">
                <WizardSuccess
                    customClassName="contribution-fund-success__container"
                    successMessage={successMessage}
                    processDetail={immContributionFunds.getIn(['contributionFunds', 'isin'])}
                >
                    <div className="account-debits-return-success__actions text-right" />
                </WizardSuccess>
                <div className="contribution-fund-success__details">
                    <FormattedText value="brokerContributionFundSuccess-details" />
                </div>
                <BrokerContributionInvestmentFundDetails
                    columns={columns}
                    columnsContent={columnsContent}
                    immAccount={immAccount}
                    immContributionFunds={immContributionFunds}
                />
                <div className="contribution-fund-success__buttons">
                    <div className="contribution-fund-success__div-buttons-right">
                        <div className="contribution-fund-success__left-button">
                            <OKButton
                                modifier="ghost"
                                to={BROKER_MYPROFILE_MYWALLET_URL + '/ordersAndMovements'}
                                onClick={handleClickMovements}
                            >
                                <FormattedText value="brokerContributionFundSuccess-askMovements" />
                            </OKButton>
                        </div>
                        <OKButton
                            modifier="secondary"
                            to={BROKER_MYPROFILE_MYWALLET_URL}
                            onClick={handleClickWallet}
                        >
                            <FormattedText value="brokerContributionFundSuccess-finish" />
                        </OKButton>
                    </div>
                    <div className="clearfix" />
                </div>
            </div>
        );
    }
}

BrokerContributionInvestmentFundSuccess.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immContributionFunds: PropTypes.object.isRequired
};

module.exports = BrokerContributionInvestmentFundSuccess;
